import { WatchQueryFetchPolicy, ErrorPolicy } from '@apollo/client';

/**
 * Shared `useQuery` options for the homepage sections that own a query.
 *
 * `fetchPolicy: 'cache-and-network'` shows cached data immediately while a
 * fresh network request runs in the background, so a section never flashes
 * a skeleton it doesn't need to.
 *
 * `errorPolicy: 'none'` discards partial data on a GraphQL error. With `'all'`,
 * a failing subquery (e.g. `user: null` alongside an error) writes that partial
 * shape into the normalised cache and blanks every other section reading the
 * same entity. The trade is a section showing its own error rather than
 * poisoning its siblings.
 *
 * `notifyOnNetworkStatusChange: true` makes `loading` flip back to `true`
 * during a background refetch (not just the initial fetch), which the retry
 * affordance in each section's error branch depends on.
 */
export const HOME_SECTION_QUERY_OPTIONS: {
  fetchPolicy: WatchQueryFetchPolicy;
  errorPolicy: ErrorPolicy;
  notifyOnNetworkStatusChange: boolean;
} = {
  fetchPolicy: 'cache-and-network',
  errorPolicy: 'none',
  notifyOnNetworkStatusChange: true,
};
